Vue.component('battleQueue', {
  template: templates.battleQueue,
  data() {
    return {
      model: {
        battles: {},
        hasResults: false,
        isLoading: false
      },
      twitchNameCache: {}, // Cache for Twitch names
      requestQueue: [], // Queue for pending requests
      maxConcurrentRequests: 5, // Limit for concurrent requests
      cancelTokenSource: null
    };
  },
  mounted() {
    const c = this;
    c.get();
    c.connect();
  },
  beforeDestroy() {
    const c= this;
    // c.stopSendingData();
    if (c.ws) {
      c.ws.close();
    }

    if (c.cancelTokenSource) {
      c.cancelTokenSource.cancel('Request canceled due to component destruction.');
    }
  },
  methods: {
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());

      c.ws.onmessage = (event) => {
        const messageData = event.data;
        
        try {
          const parsedData = JSON.parse(messageData);
            if((parsedData.message === 'battle_accepted' || parsedData.message === 'battle_started' || parsedData.message === 'requeue_battle') && parsedData.channelId === utils.cookies.get('channelId')){
              c.get();
            }
        }catch (error) {
          console.error('Error parsing message data:', error);
        }
      };

      c.ws.onopen = () => {
        console.log('WebSocket connection established');
      };

      c.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    },
    async get() {
      const c = this;
      
      if (c.cancelTokenSource) {
        c.cancelTokenSource.cancel('Previous request canceled.');
      }

      c.cancelTokenSource = axios.CancelToken.source();

      try {
        const response = await battleService.getQueue({ cancelToken: c.cancelTokenSource.token });
        if(response.data === ''){
          return;
        }
        c.model.isLoading = true;
        c.model.hasResults = true;
        const data = {};
        for (let d of response.data) {
          d.queue = true;
          data[`${d.id}`] = d;
        }
        await c.getTwitchNames(data);
      } catch (error) {

        if (axios.isCancel(error)) {
          console.log('Request canceled:', error.message);
        } else {
          c.model.hasResults = false;
          console.error("Error fetching battle queue:", error);
        }
        
      }
      console.log(c.model)
    },
    async getTwitchNames(data) {
      const c = this;
      const ids = [];
      for (let key in data) {
        const user1Id = data[key].user1TwitchId;
        const user2Id = data[key].user2TwitchId;

        if (user1Id && !c.twitchNameCache[user1Id]) {
          ids.push(user1Id);
        }
        if (user2Id && !c.twitchNameCache[user2Id]) {
          ids.push(user2Id);
        }
      }

      // Batch requests if there are IDs to fetch
      if (ids.length > 0) {
        await c.fetchTwitchNamesInBatches(ids, data);
      } else {
        c.model.battles = data;
      }
    },
    async fetchTwitchNamesInBatches(ids, data) {
      const c = this;
      const batches = c.chunkArray(ids, 100); // Chunk IDs into batches of 100
      for (const batch of batches) {
        await c.fetchTwitchNames(batch, data);
      }
    },
    async fetchTwitchNames(batch, data) {
      const c = this;
      const url = `${apiUrl}users?${batch.map(id => `id=${id}`).join('&')}`;

      try {
        const response = await axios.get(url, {
          headers: {
            'Client-ID': clientId,
            Authorization: `Bearer ${utils.cookies.get('access_token')}`,
          },
        });

        // Cache the results
        response.data.data.forEach(user => {
          c.twitchNameCache[user.id] = user.display_name;
        });

        c.processTwitchNames(data, response.data.data);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          await authentication.refreshAccessToken();
          await c.fetchTwitchNames(batch, data); // Retry after refreshing token
        } else {
          console.error("Error fetching Twitch names:", error);
        }
      }
    },
    processTwitchNames(data, result) {
      const c = this;
      for (let d of result) {
        for (let key in data) {
          if (data[key].user1TwitchId === d.id) {
            data[key].user1TwitchDisplayName = d.display_name;
          } else if (data[key].user2TwitchId === d.id) {
            data[key].user2TwitchDisplayName = d.display_name;
          }
        }
      }
      c.model.battles = data;
    },
    chunkArray(array, chunkSize) {
      const c = this;
      const result = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
      }
      return result;
    },
    start(id) {
      const c = this;
      const data = c.model.battles[`${id}`];
      battleService.save(data)
        .then(res => {
          if(res.data.status === 400){
            utils.alert.error(res.data.message);
          }
          else{


            c.model.battles[`${id}`].queue = false;

            const messageData = {
              message: 'battle_started',
              channelId: utils.cookies.get('channelId'),
              username1: data.twitch1DisplayName[0].twitchDisplayName,
              username2: data.twitch2DisplayName[0].twitchDisplayName,
            };

            c.ws.send(JSON.stringify(messageData));
          }
          
        })
        .catch(error => {
          console.error("Error starting battle:", error);
        });
    },
    cancel(id) {
      const c = this;
        
      if (confirm('Are you sure you want to remove this battle from the queue?')) {
        battleService.cancel ({ id: id })
          .then(() => {
            const data = c.model.battles[`${id}`];
            const messageData = {
              message: 'battle_canceled',
              channelId: utils.cookies.get('channelId'),
              username1: data.twitch1DisplayName[0].twitchDisplayName,
              username2: data.twitch2DisplayName[0].twitchDisplayName,
            };

            c.ws.send(JSON.stringify(messageData));
            
            c.model.battles[`${id}`].queue = false;

          })
          .catch(error => {
            console.error("Error canceling battle:", error);
          });
      }
    },
  },
});